// ======================================================================
// File Name       : archivement
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/archivement';

export function receiveUserList(userSearchResult, searchParam) {
  return {
    type: ActionTypes.USER_RECEIVE_USER_LIST,
    userList: userSearchResult.userList,
    recordNum: userSearchResult.recordNum,
    reportApprovalDateFrom: searchParam.searchInfo
      ? searchParam.searchInfo.reportApprovalDateFrom
      : null,
    reportApprovalDateTo: searchParam.searchInfo
      ? searchParam.searchInfo.reportApprovalDateTo
      : null,
  };
}

export function receiveAuthorityList(responseData) {
  return {
    type: ActionTypes.USER_RECEIVE_AUTHORITY_LIST,
    managementAuthorityList: responseData.managementAuthorityList,
  };
}

export function receiveReportOperationCount(responseData) {
  return {
    type: ActionTypes.USER_RECEIVE_REPORT_OPERATION_COUNT,
    reportOperationCountList: responseData && responseData.checkerUserList,
  };
}

export function receiveReportOperationList(responseData) {
  return {
    type: ActionTypes.USER_RECEIVE_REPORT_OPERATION_LIST,
    reportList: responseData.reportList,
    recordNum: responseData.recordNum,
  };
}

export function receiveMappingUser(userSearchResult) {
  return {
    type: ActionTypes.USER_RECEIVE_MAPPING_USER,
    userDetailList: userSearchResult.userList,
  };
}
